import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
  name: 'quote',
  initialState: {
    quote: {},
    fees: [],
    accommodations: [],
    courses: [],
    payments: {
      linktype: 0,
      totalDiscountInReais: 0,
      totalDiscountPercentage: 0,
      pravalerInstalment: 0,
      poupancinha: [],
      creditCardWithEntry: [],
      creditCardNoEntry: [],
    },
  },
  reducers: {
    changeQuote(state, { payload }) {
      return { ...state, quote: { ...payload } };
    },
    changeFees(state, { payload }) {
      const { fees } = state;
      const previouseAddedFee = fees.some(
        ({ id: feeId }) => feeId === payload.id,
      );
      if (state.quote.fees.length > state.fees.length && !previouseAddedFee) {
        return { ...state, fees: [...state.fees, payload] };
      }
      return { ...state };
    },
    changeAccommodations(state, { payload }) {
      if (state.quote.accommodations.length > state.accommodations.length) {
        return { ...state, accommodations: [...state.accommodations, payload] };
      }
      return { ...state };
    },
    changeCourses(state, { payload }) {
      if (state.quote.courses.length > state.courses.length) {
        return { ...state, courses: [...state.courses, payload] };
      }
      return { ...state };
    },
    changePayments(state, { payload }) {
      return { ...state, payments: payload };
    },
  },
});

export const {
  changeQuote,
  changeFees,
  changeAccommodations,
  changeCourses,
  changePayments,
} = slice.actions;
export const selectQuote = (state) => state.quote;
export default slice.reducer;
